import React from 'react';
import proptypes from 'prop-types';
const { arrayOf, shape, string, number, bool, elementType } = proptypes;
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';

import {
  TableStatusPlaceholder,
  CardStatusPlaceholder,
} from '../../placeholders/orderDetailsLoading';
import { TableStatusMessage, CardStatusMessage } from './StatusMessage';

export function OrderStatus({
  customerInfo = {},
  isOnline = false,
  layout = undefined,
  order = {},
  OrderDetailsType = undefined,
}) {
  const id = isOnline ? order.orderNumbers[0] : order.receiptDetails;
  const detailsSource = 'orderDetails';

  return (
    <QueryProvider cacheKey={`recent-purchases-item-${id}`}>
      <OrderDetailsType order={order} customerInfo={customerInfo}>
        {({ data, loading }) => {
          if (layout === 'card') {
            return loading ? (
              <CardStatusPlaceholder />
            ) : (
              <CardStatusMessage
                orderStatus={
                  data?.[detailsSource]?.statusDescription
                    ? data?.[detailsSource]?.statusDescription
                    : null
                }
              />
            );
          }

          return loading ? (
            <TableStatusPlaceholder />
          ) : (
            <TableStatusMessage
              orderStatus={
                data?.[detailsSource]?.statusDescription
                  ? data[detailsSource]?.statusDescription
                  : null
              }
            />
          );
        }}
      </OrderDetailsType>
    </QueryProvider>
  );
}

export function LazyOrderStatus({
  isOnline = false,
  OrderDetailsType = undefined,
  order = {},
  customerInfo = {},
  layout = undefined,
  index = undefined,
}) {
  const id = isOnline ? order.orderNumbers[0] : order.receiptDetails;
  const detailsSource = 'orderDetails';

  return (
    <Hydrator
      id={`recent-purchases-status-hydrator-${id}-${layout}-${index}`}
      placeholder={
        layout === 'card' ? (
          <CardStatusPlaceholder />
        ) : (
          <TableStatusPlaceholder />
        )
      }
      delay={1200}
    >
      <OrderStatus
        order={order}
        customerInfo={customerInfo}
        layout={layout}
        detailsSource={detailsSource}
        OrderDetailsType={OrderDetailsType}
        isOnline={isOnline}
      />
    </Hydrator>
  );
}

OrderStatus.propTypes = {
  customerInfo: shape({
    customerAccountId: string,
    userId: string,
  }),
  isOnline: bool,
  layout: string,
  order: shape({
    salesDate: string,
    orderNumber: string,
    orderNumbers: arrayOf(string),
    totalAmount: number,
    storeName: string,
    accountIdUsed: string,
    accountIdType: string,
    showReceiptImage: bool,
    receiptDetails: string,
    registerNumber: number,
    orderOrigin: string,
    rewardsDiscountAmount: number,
    otherDiscountAmount: number,
    preTaxAmount: number,
    receiptAddedDate: string,
    showBigReceipt: bool,
    purchaserId: string,
    detailsSource: string,
    invoiceNumbers: number,
    invoiceNumbersForCSV: number,
    isGiftCardPerksUsed: bool,
    preferredDiscFlg: string,
    transactionId: number,
    POJobName: string,
  }),
  OrderDetailsType: elementType,
};

LazyOrderStatus.propTypes = {
  customerInfo: shape({
    customerAccountId: string,
    userId: string,
  }),
  isOnline: bool,
  layout: string,
  order: shape({
    salesDate: string,
    orderNumber: string,
    orderNumbers: arrayOf(string),
    totalAmount: number,
    storeName: string,
    accountIdUsed: string,
    accountIdType: string,
    showReceiptImage: bool,
    receiptDetails: string,
    registerNumber: number,
    orderOrigin: string,
    rewardsDiscountAmount: number,
    otherDiscountAmount: number,
    preTaxAmount: number,
    receiptAddedDate: string,
    showBigReceipt: bool,
    purchaserId: string,
    detailsSource: string,
    invoiceNumbers: number,
    invoiceNumbersForCSV: number,
    isGiftCardPerksUsed: bool,
    preferredDiscFlg: string,
    transactionId: number,
    POJobName: string,
  }),
  OrderDetailsType: elementType,
  index: number,
};
